import { BaseEntityDTO, IBaseEntityDTO } from './base.entity.dto';
import { EntryDTO, IEntryDTO } from './entry.dto';
import { EntryFieldDTO, IEntryFieldDTO } from './entry.field.dto';

export interface IEntrySectionDTO extends IBaseEntityDTO {
  name: string;
  order: number;
  fields: IEntryFieldDTO[];
  entry: IEntryDTO;
}

export class EntrySectionDTO extends BaseEntityDTO implements IEntrySectionDTO {
  name: string;
  order: number;
  fields: IEntryFieldDTO[];
  entry: IEntryDTO;
  constructor(data?: Partial<IEntrySectionDTO>) {
    super(data);
    this.name = data?.name ?? '';
    this.order = data?.order ?? 0;
    this.fields = data?.fields ? data.fields.map((field) => new EntryFieldDTO(field)) : [];
    this.entry = data?.entry ? new EntryDTO(data.entry) : new EntryDTO();
  }
}
